import React from "react";

import ACIconWrapper, { ACIconProps } from "./ACIconWrapper";

export default function SlaChartIcon(props: ACIconProps) {
  return <ACIconWrapper component={IconSvg} {...props} />;
}

const IconSvg = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="1em"
      viewBox="0 0 36 36"
      fill="none"
    >
      <g clip-path="url(#clip0_361_995)">
        <path
          d="M4 12.5C4 11.6716 4.67157 11 5.5 11H30.5C31.3284 11 32 11.6716 32 12.5C32 13.3284 31.3284 14 30.5 14H5.5C4.67157 14 4 13.3284 4 12.5Z"
          fill="#CCBFFF"
        />
        <path
          d="M26.5 11C27.3284 11 28 11.6716 28 12.5C28 13.3284 27.3284 14 26.5 14L5.5 14C4.67157 14 4 13.3284 4 12.5C4 11.6716 4.67157 11 5.5 11L26.5 11Z"
          fill="#927BF0"
        />
      </g>
      <g clip-path="url(#clip1_361_995)">
        <path
          d="M4 18.5C4 17.6716 4.67157 17 5.5 17H30.5C31.3284 17 32 17.6716 32 18.5C32 19.3284 31.3284 20 30.5 20H5.5C4.67157 20 4 19.3284 4 18.5Z"
          fill="#CCBFFF"
        />
        <path
          d="M22.5 17C23.3284 17 24 17.6716 24 18.5C24 19.3284 23.3284 20 22.5 20L5.5 20C4.67157 20 4 19.3284 4 18.5C4 17.6716 4.67157 17 5.5 17L22.5 17Z"
          fill="#927BF0"
        />
      </g>
      <g clip-path="url(#clip2_361_995)">
        <path
          d="M4 24.5C4 23.6716 4.67157 23 5.5 23H30.5C31.3284 23 32 23.6716 32 24.5C32 25.3284 31.3284 26 30.5 26H5.5C4.67157 26 4 25.3284 4 24.5Z"
          fill="#CCBFFF"
        />
        <path
          d="M17.5 23C18.3284 23 19 23.6716 19 24.5C19 25.3284 18.3284 26 17.5 26L5.5 26C4.67157 26 4 25.3284 4 24.5C4 23.6716 4.67157 23 5.5 23L17.5 23Z"
          fill="#927BF0"
        />
      </g>
      <g clip-path="url(#clip3_361_995)">
        <path
          d="M4 30.5C4 29.6716 4.67157 29 5.5 29H30.5C31.3284 29 32 29.6716 32 30.5C32 31.3284 31.3284 32 30.5 32H5.5C4.67157 32 4 31.3284 4 30.5Z"
          fill="#CCBFFF"
        />
        <path
          d="M13.5 29C14.3284 29 15 29.6716 15 30.5C15 31.3284 14.3284 32 13.5 32L5.5 32C4.67157 32 4 31.3284 4 30.5C4 29.6716 4.67157 29 5.5 29L13.5 29Z"
          fill="#927BF0"
        />
      </g>
      <defs>
        <clipPath id="clip0_361_995">
          <path
            d="M4 12.5C4 11.6716 4.67157 11 5.5 11H30.5C31.3284 11 32 11.6716 32 12.5C32 13.3284 31.3284 14 30.5 14H5.5C4.67157 14 4 13.3284 4 12.5Z"
            fill="white"
          />
        </clipPath>
        <clipPath id="clip1_361_995">
          <path
            d="M4 18.5C4 17.6716 4.67157 17 5.5 17H30.5C31.3284 17 32 17.6716 32 18.5C32 19.3284 31.3284 20 30.5 20H5.5C4.67157 20 4 19.3284 4 18.5Z"
            fill="white"
          />
        </clipPath>
        <clipPath id="clip2_361_995">
          <path
            d="M4 24.5C4 23.6716 4.67157 23 5.5 23H30.5C31.3284 23 32 23.6716 32 24.5C32 25.3284 31.3284 26 30.5 26H5.5C4.67157 26 4 25.3284 4 24.5Z"
            fill="white"
          />
        </clipPath>
        <clipPath id="clip3_361_995">
          <path
            d="M4 30.5C4 29.6716 4.67157 29 5.5 29H30.5C31.3284 29 32 29.6716 32 30.5C32 31.3284 31.3284 32 30.5 32H5.5C4.67157 32 4 31.3284 4 30.5Z"
            fill="white"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
